import MiniProgramPage from 'D:/zxl/workspace/saveWorkSpace/nongtou-uni/subpackage/login/login.vue'
wx.createPage(MiniProgramPage)